
import React, { useState, useEffect } from "react";
import { Account } from "./orchestration/types";
import { VirtualTeamSection } from "./orchestration/components/VirtualTeamSection";
import { KeyRequestsSection } from "./orchestration/components/KeyRequestsSection";
import { getAccountOwnershipInfo } from "./business-value-framework/accountService";
import { supabase } from "@/integrations/supabase/client";

const OrchestrationTab = ({ selectedAccount }: { selectedAccount: Account | null }) => {
  const [isOwner, setIsOwner] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [ownershipLoaded, setOwnershipLoaded] = useState(false);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    
    getUser();
  }, []);

  useEffect(() => {
    const loadOwnershipInfo = async () => {
      if (selectedAccount?.company_id && user) {
        const ownershipInfo = await getAccountOwnershipInfo(selectedAccount.company_id);
        setIsOwner(ownershipInfo.isOwner);
        setCanEdit(ownershipInfo.canEdit);
        
        // Only set as supervisor if user can view but is not the owner
        setIsSupervisor(ownershipInfo.canView && !ownershipInfo.isOwner);
        setOwnershipLoaded(true);
      } else {
        setOwnershipLoaded(false);
      }
    };

    loadOwnershipInfo();
  }, [selectedAccount, user]);

  return (
    <div className="space-y-2">
      {ownershipLoaded && isSupervisor && (
        <div className="mb-2 p-1 bg-primary/20 text-primary border-primary/30 rounded-lg">
          <div className="flex items-center justify-between">
            <p className="text-xs text-secondary-800">
              You are viewing this account as a supervisor. Only the account owner can add, edit, or delete team members and requests.
            </p>
          </div>
        </div>
      )}
      
      <VirtualTeamSection selectedAccount={selectedAccount} canEdit={canEdit} />
      <KeyRequestsSection selectedAccount={selectedAccount} canEdit={canEdit} />
    </div>
  );
};

export default OrchestrationTab;
